export enum StorageKeys {
  KEY_COMPANY = 'selectedCompany',
  KEY_COMPANY_BRANCHES = 'selectedCompanyBranches',
  KEY_PERIOD = 'selectedPeriod',
  KEY_PASSWORD_RESTORE_DATA = 'restorePasswordData',
  KEY_THEME = 'selectedTheme',
  KEY_LOGGED_USER = 'loggedUser',
  KEY_LOGGED_USER_COMPANIES = 'loggedUserCompanies',
  KEY_TOKEN = 'token',
  KEY_REFRESH_TOKEN = 'refreshToken',
  KEY_EXPIRATION_TOKEN = 'expirationToken',
  KEY_EXPIRATION_TOKEN_TIMESTAMP = 'expirationTokenTimestamp',
  KEY_REFRESH_TOKEN_EXPIRATION_TIME = 'refreshTokenExpirationTime',
  KEY_LAST_COMPANY = 'lastCompany',
  KEY_LAST_PERIOD = 'lastPeriod',
  KEY_LAST_COMPANY_BRANCHES = 'lastCompanyBranches',
  KEY_2FA_PREFERRED_AUTH = '2faPreferredAuth',
  KEY_2FA_CODE_SENT = 'codeSent',
  KEY_2FA_REQUEST_USER_PHONE = '2faRequestUserPhone',
  KEY_2FA_SECRET_URI = '2faSecretUri',
  KEY_2FA_TOTP_VALIDATED = '2faTotpValidated'
}
